import { StrengthMeterInterface } from '@/components/strength-meter/StrengthMeterInterface';
import { socketClient } from '@/core/node-client';
import { getAssetsBlocks } from '@/helpers/strengthMeterHelpers';

const userInterface = new StrengthMeterInterface(
  '#str-meter-currencies',
  getAssetsBlocks
);

socketClient.currencyStrengthHistory().then((instrumentsData) => {
  userInterface.initializeUserInterface(instrumentsData);
});
